import React from 'react';
import type { Enrollment as EnrollmentModel } from 'models/enrollments/Enrollment';
import type { FormEnrollment as FormEnrollmentModel, FormEnrollmentDto } from 'models/enrollments/FormEnrollment';
import FormEnrollmentView from './FormEnrollmentView';
import type { UserSubmissionDto } from 'models/projects/UserSubmissionDto';

type Props = {
  enrollment?: EnrollmentModel | FormEnrollmentModel | FormEnrollmentDto | null;
  className?: string;
  onSubmit?: (submissionDto: UserSubmissionDto) => void;
  workflowId?: string;
  nodeId?: string;
  projectId?: string;
  isDisabled?: boolean;
};


export const EnrollmentView: React.FC<Props> = ({ enrollment = null, className = '', onSubmit, workflowId, nodeId, projectId, isDisabled }) => {
  if (!enrollment) return null;

  if (isFormEnrollmentModel(enrollment) || isFormEnrollmentDto(enrollment) || isFormEnrollment(enrollment)) {
    return <FormEnrollmentView enrollment={enrollment as any} className={className} onSubmit={onSubmit} workflowId={workflowId} nodeId={nodeId} projectId={projectId} isDisabled={isDisabled} />;
  }

  // fallback renderer
  const typeLabel = (enrollment as any)?.type ?? (enrollment as any)?.enrollmentType ?? 'unknown';
  return (
    <div className={`p-4 border rounded bg-white text-sm text-gray-600 ${className}`}>
      <div>No renderer for enrollment type: <code className="bg-gray-50 px-2 py-0.5 rounded">{typeLabel}</code></div>
      <pre className="mt-2 text-xs bg-gray-50 p-2 rounded overflow-auto">{JSON.stringify(enrollment, null, 2)}</pre>
    </div>
  );
};


const isFormEnrollmentDto = (e: unknown): e is FormEnrollmentDto => {
  return !!e && typeof e === 'object' && 'formId' in (e as any);
};

const isFormEnrollmentModel = (e: unknown): e is FormEnrollmentModel => {
  return !!e && typeof e === 'object' && (e as any).constructor?.name === 'FormEnrollment';
};

const isFormEnrollment = (enrollment: any): enrollment is FormEnrollmentModel => {
        return enrollment && "form" in enrollment && enrollment.form?.name;
      };

export default EnrollmentView;
